import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {PageService} from "../../models/PageService";
import { EnvironmentService } from 'src/app/services/environment.service';

@Injectable({
  providedIn: 'root'
})
export class PageServiceService {

  BASE_URL = '/ws/rest';
  PAGE_SERVICE = '/pageService';
  Have_Hiarchi = "/entreprises/have_hiarchi";
  constructor(private readonly http: HttpClient, private environmentService: EnvironmentService) {}
  getPageServiceList(): Observable<any> {
    return this.http.get<any>(this.environmentService.get().serverUrl + this.BASE_URL + this.PAGE_SERVICE + '/getPageServices');
  }

  getPageServiceById(id:string): Observable<PageService> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('id', id);
    return this.http.get<PageService>(this.environmentService.get().serverUrl + this.BASE_URL + this.PAGE_SERVICE + '/getPageServiceById', { params: queryParams });
  }
  public getHaveHiarchi(): Observable<any> {
    return this.http.get<any>(this.environmentService.get().serverUrl + this.BASE_URL + this.Have_Hiarchi)
}

getRouting() : Observable<any>{
  return this.http.get<any>(this.environmentService.get().serverUrl + this.BASE_URL + '/gestion_menu/get_routing');
}

}
